"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
const GetDefaultPropositionsResponseProductDetails_1 = tslib_1.__importDefault(require("./GetDefaultPropositionsResponseProductDetails"));
const GetDefaultPropositionsResponseProductCashbackItems_1 = tslib_1.__importDefault(require("./GetDefaultPropositionsResponseProductCashbackItems"));
class GetDefaultPropositionsResponseProduct extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: '125', description: 'The campaign ID' }),
    tslib_1.__metadata("design:type", String)
], GetDefaultPropositionsResponseProduct.prototype, "productId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({
        example: '2022-01-20T00:00:00.000Z',
        description: 'The date and time from when the changes should go live. When null (or not provided) the proposed starting date will be now.',
    }),
    tslib_1.__metadata("design:type", Date)
], GetDefaultPropositionsResponseProduct.prototype, "startingDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => GetDefaultPropositionsResponseProductDetails_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    tslib_1.__metadata("design:type", GetDefaultPropositionsResponseProductDetails_1.default)
], GetDefaultPropositionsResponseProduct.prototype, "productVersionDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => GetDefaultPropositionsResponseProductCashbackItems_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    tslib_1.__metadata("design:type", Array)
], GetDefaultPropositionsResponseProduct.prototype, "productVersionCashbackItems", void 0);
exports.default = GetDefaultPropositionsResponseProduct;
